import FlowFieldCanvas from "./FlowFieldCanvas";

const TourLaunchDialog = ({ onStart, onSkip }) => {
  return (
    <div className="et-launch">
      <FlowFieldCanvas />
      <div className="et-launch__card">
        <div className="et-launch__header">
          <div className="et-launch__badge">GUIDED DEMO</div>
          <h2 className="et-launch__title">
            Welcome to The Buyer Listing Service{"\u00AE"}
          </h2>
          <p className="et-launch__subtitle">
            The buy side of the MLS - powered by Gitcha.
          </p>
        </div>

        <p className="et-launch__desc">
          See how real-time buyer demand data, AI-powered matching, and seller
          reports give you a competitive edge in every listing conversation.
        </p>

        <button className="et-launch__start" onClick={onStart}>
          Start the Tour
          <span className="et-launch__start-arrow">&rarr;</span>
        </button>

        <span className="et-launch__time">Takes about 5 minutes</span>

        <button className="et-launch__skip" onClick={onSkip}>
          I'll explore on my own
        </button>
      </div>
    </div>
  );
};

export default TourLaunchDialog;
